import React, { useState, useEffect } from "react";
import api from "@api";
import { Form } from "@components";
import { RoleModel, RoleApproverModel } from "@api/types/role";
import { RoleDetail } from "./detail";
import { M_TABLE_HEADERS_ROLE } from "../constants";
import { Cell } from "@components/table/types";
import { Box, Button } from "@material-ui/core";
import { FilterType, Table } from "@components";
import { useRoleStore } from "../../../../../store/hooksy";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportMaintenanceRoles } from "@api/excel-exporters/exportMaintenanceRoles";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_ROLE.ROLE_NAME },
  { data: M_TABLE_HEADERS_ROLE.IS_ACTIVE },
  { data: M_TABLE_HEADERS_ROLE.SYSTEM_APP_NAME },
  { data: M_TABLE_HEADERS_ROLE.SYSTEM_TYPE },
  { data: M_TABLE_HEADERS_ROLE.SYSTEM_CATEGORY },
];

export const Role: React.FC = () => {
  const [roleStore, setRoleStore] = useRoleStore();

  useEffect(() => {
    if (roleStore.fetchList) {
      getDataList();
    }
  }, [roleStore]);

  const form = Form.useManager<RoleModel>({
    id: 0,
    roleName: "",
    description: "",
    systemAppName: "",
    systemAppNameId: 0,
    systemType: "",
    systemCategory: "",
    isActive: false,
  });

  const [openRole, setOpenRole] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedRole, setSelectedRole] = useState<RoleModel>();
  const [roleList, setRoleList] = useState([]);
  const [roleListMain, setRoleListMain] = useState([]);
  const [isHideInactiveRecords, setIsHideInactiveRecords] = useState<boolean>(
    true
  );

  useEffect(() => {
    getDataList(true);
  }, []);

  useEffect(() => {
    if (openRole) {
      if (selectedRole) {
        form.set(Form.target.VALUE, ["id", selectedRole.id]);
        form.set(Form.target.VALUE, ["roleName", selectedRole.roleName]);
        form.set(Form.target.VALUE, ["description", selectedRole.description]);
        form.set(Form.target.VALUE, [
          "systemAppNameId",
          selectedRole.systemAppNameId,
        ]);
        form.set(Form.target.VALUE, ["isActive", selectedRole.isActive]);
      }
    }
  }, [openRole]);

  useEffect(() => {
    if (isHideInactiveRecords) {
      const roleListFiltered = roleListMain.filter(
        (role: any) => role.isActive === isHideInactiveRecords
      );
      setRoleList(roleListFiltered);
    } else {
      setRoleList(roleListMain);
    }
  }, [isHideInactiveRecords, roleListMain]);

  function getDataList(isInitialLoad: boolean = false) {
    setIsLoading(true);
    api.maintenancerole
      .get()
      .then((response) => {
        setRoleList(response);
        if (isInitialLoad) {
          setRoleListMain(response);
        }
      })
      .catch((error) => {
        console.error(`Error in fetching role ${error}`);
      })
      .then(() => {
        setIsLoading(false);
      });
  }

  const isShowModal = openRole ? (
    <RoleDetail
      form={form}
      open={openRole}
      onCancel={() => setOpenRole(false)}
    />
  ) : (
    ""
  );

  function handleExport() {
    const isActive = isHideInactiveRecords ? 1 : 0;
    exportMaintenanceRoles(isActive);
  }

  function onChange(): void {
    setIsHideInactiveRecords((prev) => !prev);
  }

  const pageName = "Roles";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Box style={{ float: "right" }}>
        <Form.Checkbox
          label="Hide Inactive Records"
          name="isHideInactiveRecords"
          onChange={onChange}
          size={12}
          value={isHideInactiveRecords}
        />
        <Button onClick={handleExport}>EXPORT TO EXCEL</Button>
      </Box>
      <Table
        data={roleList.map((data: RoleModel) => ({
          cells: [
            {
              data: data.roleName,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedRole(data);
                setOpenRole(true);
              },
            },
            {
              data: data.isActive ? "Yes" : "No",
            },
            {
              data: data.systemAppName,
            },
            {
              data: data.systemType,
            },
            {
              data: data.systemCategory,
            },
          ],
          data,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[
          M_TABLE_HEADERS_ROLE.ROLE_NAME,
          M_TABLE_HEADERS_ROLE.SYSTEM_APP_NAME,
        ]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_ROLE_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
    </Box>
  );
};
